import React, { useEffect, useState } from "react";
import weather from "openweather-apis";

import weatherKey from "../weatherKey";
import helpers from "../helpers";

export default () => {
  const [data, setData] = useState();
  // passing empty array as second arg treats this similarly to componentDidMount
  useEffect(() => {
    // weather.setLang('en'); 
    // weather.setCity('Austin');
 	  // weather.setUnits('imperial');
 
    // // check http://openweathermap.org/appid#get for get the APPID
 	  // weather.setAPPID(weatherKey);

    // weather.getAllWeather(function(err, res){
    //   console.log(err)
    //   setData({
    //     temp: res?.main.temp,
    //     condition: res?.weather[0].description,
    //     img: res?.weather[0].icon
    //   })
    // });
    helpers.getWeather().then(response => {
      const weatherData = response.data.current 
      if (weatherData) {
setData({temp: weatherData.temperature, condition: weatherData.weather_descriptions[0] ?? '', img:weatherData.weather_icons[0]})
      }
      
    }).catch(error => console.log(error))
  }, []);

  if (data) {
    return(
    <div className="weather">
      <h2>Current Weather in Austin, TX</h2>
      <div className="weather-info">
        <p>{data && data.temp} F</p>
      </div>
    </div>
  )
  } else return (
    <div className="weather">
    </div>
  )

};
